"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalLayer = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const React = __importStar(require("react"));
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = require("styled-components");
const _1 = require(".");
const close_icon_1 = require("./icons/close-icon");
/**
 * Create a box shadow depending on a shadow color
 *
 * @param themeShadowColor The color of the drop shadow as provided by the current theme
 */
const createCssBoxShadow = (themeShadowColor) => {
    const defaultBoxShadow = 'box-shadow: initial;';
    if (!themeShadowColor) {
        return defaultBoxShadow;
    }
    const darkShadowColor = (0, components_core_1.hexColorToRgba)(themeShadowColor, 0.1);
    const lightShadowColor = (0, components_core_1.hexColorToRgba)(themeShadowColor, 0.05);
    // intentionally used hard coded px values here since they aren't theme-related and probably don't need a reusable variable
    return `box-shadow: 0 8px 32px 0 ${darkShadowColor}, 0 16px 48px 0 ${lightShadowColor};`;
};
const animationClassName = 'animation';
const StyledLayer = components_core_1.styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.background.primary};
  ${props => createCssBoxShadow(props.theme.shadows.variant1)};
  opacity: 1;
  transform: translateY(0);

  transition: ${props => {
    const duration = props.theme.animation.duration.layer;
    const timingFunction = props.theme.animation.timingFunction.in;
    return `opacity ${duration} ${timingFunction}, transform ${duration} ${timingFunction}`;
}};

  &.${animationClassName}-exit {
    opacity: 1;
    transform: translateY(0);
  }

  &.${animationClassName}-enter,
    &.${animationClassName}-exit-active,
    &.${animationClassName}-exit-done {
    opacity: 0;
    transform: translateY(${props => props.theme.size.static500});
  }

  /*
    this must be separate from the animation-exit definition because the order in the CSS must be in a specific order
    for the animation to work and some of the values for the animation are breakpoint specific.
    * <name>-<state> => breakpoint specific for enter
    * <name>-<state>-active => breakpoint specific for exit
    * <name>-<state>-done (if needed) => breakpoint specific for exit
  */
  &.${animationClassName}-enter-active {
    opacity: 1;
    transform: translateY(0);
  }

  min-height: 100%;
`;
const StyledLayerScrollContainer = components_core_1.styled.div `
  height: auto;
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;
const StyledModalWrapper = components_core_1.styled.div `
  padding: 0px;
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  @media (min-width: ${components_core_1.Breakpoints.b960}px) {
    padding: 100px;
    ${props => props.modalPadding && ` padding: ${props.modalPadding};`}
  }

  ${props => props.maxWidth &&
    `max-width: ${props.maxWidth}; display: block; margin: 0 auto;`}

  transition: ${props => {
    const duration = props.theme.animation.duration.layer;
    const timingFunction = props.theme.animation.timingFunction.in;
    return `opacity ${duration} ${timingFunction}, transform ${duration} ${timingFunction}`;
}};

  &.${animationClassName}-exit {
    opacity: 1;
    transform: translateY(0);
  }

  &.${animationClassName}-enter,
    &.${animationClassName}-exit-active,
    &.${animationClassName}-exit-done {
    opacity: 0;
    transform: translateY(${props => props.theme.size.static500});
  }
  &.${animationClassName}-enter-active {
    opacity: 1;
    transform: translateY(0);
  }
`;
const StyledCloseWrapper = components_core_1.styled.div `
  position: fixed;
  top: 10px;
  right: 10px;
  background: transparent;
  display: flex;
  justify-content: flex-end;
  z-index: 1000;
  @media (min-width: ${components_core_1.Breakpoints.b960}px) {
    top: 28px;
    right: 0;
    left: 0;
    width: 100vw;
    padding-right: 28px;
  }
`;
const InternalModalLayer = props => {
    const { active, ariaLabelledBy, children, in: visible, onExited, hideCloseIcon = false, maxWidth, modalPadding, ariaLabel, closeButtonAriaLabel } = props;
    return (React.createElement(react_transition_group_1.CSSTransition, { classNames: animationClassName, onExited: onExited, in: visible, timeout: parseInt(props.theme.animation.duration.layer || '0', 10) },
        React.createElement(StyledModalWrapper, { maxWidth: maxWidth, modalPadding: modalPadding, ref: props.scrollRef, className: "internal-modal-layer-wrapper" },
            hideCloseIcon ? null : (React.createElement(StyledCloseWrapper, { className: "close-wrapper" },
                React.createElement(_1.ClickableIcon, { "aria-label": closeButtonAriaLabel, onClick: props.onCloseHandler, autofocus: true },
                    React.createElement(close_icon_1.CloseIcon, null)))),
            React.createElement(StyledLayer, { role: "dialog", "aria-modal": active, "aria-labelledby": ariaLabelledBy, "aria-label": ariaLabel },
                React.createElement(StyledLayerScrollContainer, { className: "layer-scroll-container" }, children)))));
};
exports.ModalLayer = (0, styled_components_1.withTheme)(InternalModalLayer);
